// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_be-b";
export var colorBlue = "_be-8";
export var colorDot = "_be-0";
export var colorDotLarge = "_be-2";
export var colorDotSmall = "_be-1";
export var colorGreen = "_be-7";
export var colorGrey = "_be-3";
export var colorOrange = "_be-5";
export var colorPink = "_be-a";
export var colorPurple = "_be-9";
export var colorRed = "_be-4";
export var colorYellow = "_be-6";